import {
  useUIVariantStore,
  selectVariant,
  selectHydrated,
} from '../store/uiVariantStore.js';

/**
 * Reactive UI variant selection. Every consumer subscribes to the same
 * Zustand store, so the moment any component (e.g. the ThemeFab) calls
 * `setVariant`, every other component — App.jsx included — re-renders
 * with the new value and the active page set swaps without a reload.
 *
 * Returns:
 *   {
 *     variant: 'classic' | 'cosmic' | 'summer'
 *     setVariant: (id: string) => Promise<void>
 *     ready: boolean
 *   }
 */
export function useUIVariant() {
  const variant = useUIVariantStore(selectVariant);
  const ready = useUIVariantStore(selectHydrated);
  const setVariant = useUIVariantStore((s) => s.setVariant);
  return { variant, setVariant, ready };
}
